module.exports = __webpack_public_path__ + "img/heather.92973607.jpg";